import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingScreen = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f4f4f4'
            }}
        >
            <CircularProgress sx={{ marginBottom: 2 }} />
            <Typography variant="h6">Loading dataset, please wait...</Typography>
        </Box>
    );
};

export default LoadingScreen;
